<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="header-title">
            <h4 class="m-0 title-modal">Política de Privacidade</h4>
          </div>
          <div (click)="close()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>

        <div class="modal-body">
          <div class="modal-dialog-scrollable-general">
            <div class="mt-3">
              <p><strong>Política de Privacidade – Brasil</strong></p>
              <p><strong>Versão 5 – 28 de junho de 2022</strong></p>
              <p>
                <strong>OZ CORRETORA DE CÂMBIO S.A.</strong>, sociedade por
                ações, inscrita perante o Cadastro Nacional da Pessoa Jurídica
                do Ministério da Fazenda (“CNPJ/MF”) sob o nº
                04.062.902/0001-03, com sede na Rua Tenerife, 31, Torre A, Conj.
                31, Vila Olímpia, cidade e estado de São Paulo, CEP 04548-040,
                com seu contrato social arquivado perante a Junta Comercial do
                Estado de São Paulo (“JUCESP”) sob NIRE 35.300.190.289
                (“Corretora”); visando estabelecer as melhores práticas no seu
                mercado de atuação, edita a presente "Política de Privacidade
                Brasil" ("Política"), conforme as disposições abaixo:
              </p>
              <p>
                Esta Política de Privacidade tem por objetivo esclarecer a forma
                pela qual coletamos, usamos, ou de qualquer outra forma tratamos
                seus dados pessoais. Como parte das nossas operações diárias,
                necessitamos coletar dados pessoais de nossos clientes e
                potenciais clientes com o intuito de fornecer os nossos Produtos
                e Serviços alinhados aos valores, interesses e perfil de cada
                um.
              </p>
              <p>
                A privacidade de suas informações é de extrema importância e
                relevância para nós, e temos como política respeitar a
                confidencialidade, a segurança da informação e a privacidade das
                pessoas e de seus dados. Esta Política estipula como ocorrem as
                operações de tratamento de dados da Corretora, suas subsidiárias
                e afiliadas, bem como, terceiros atuantes nas operações
                contratadas em conformidade com as leis e regulamentações
                vigentes e é destinada especificamente aos clientes que
                utilizaram ou utilizam nossos Produtos e Serviços no território
                nacional brasileiro ou em outro lugar em que a Corretora tenha
                operação.
              </p>
              <ol>
                <li><strong>1. Considerações Gerais</strong></li>
              </ol>
              <p>
                1.1. A Corretora respeita a privacidade de todos os titulares de
                dados pessoais, estando, desta forma, comprometida a tomar todas
                as medidas possíveis para assegurar de maneira razoável a
                proteção dos dados pessoais coletados.
              </p>
              <p>
                1.2. Todas as informações são tratadas de acordo com as leis e
                regulamentações de proteção de dados aplicáveis nos mercados em
                que a Corretora atuar.
              </p>
              <p>
                1.3. Todos os procedimentos técnicos e organizacionais estão em
                vigor para garantir que a sua informação esteja sempre segura.
                Como parte destes procedimentos, regularmente treinamos e
                conscientizamos todos os nossos colaboradores sobre a
                importância da manutenção, salvaguarda e respeito da sua
                informação pessoal e consideramos a violação da privacidade dos
                dados pessoais algo muito sério, por isso monitoramos
                constantemente e prevemos medidas disciplinares apropriadas para
                eventuais descumprimentos.
              </p>
              <ol start="2">
                <li><strong>2. Coleta de Dados Pessoais</strong></li>
              </ol>
              <p>
                2.1. A Corretora poderá utilizar diferentes formas para coletar
                dados pessoais, tais como:
              </p>
              <p>2.1.1. Fornecidos por meio do preenchimento de formulários;</p>
              <p>2.1.2. Questionários;</p>
              <p>2.1.3. E-mail;</p>
              <p>2.1.4. Sites;</p>
              <p>2.1.5. Correio;</p>
              <p>2.1.6. Aplicativos;</p>
              <p>2.1.7. Telefone;</p>
              <p>2.1.8. Contratos;</p>
              <p>2.1.9. Qualquer outro meio não previsto nesse rol;</p>
              <p>
                2.2. A Corretora coleta e trata os seguintes dados sobre Você:
              </p>
              <p>2.2.1. Informações que Você nos dá:</p>
              <p>
                2.2.1.1.Informações pessoais disponibilizadas quando Você se
                inscreve para utilizar qualquer dos nossos Produtos e Serviços.
                Isso também inclui informações que Você nos fornece ao utilizar
                continuamente nossos Produtos e Serviços, ao participar de
                painéis de discussão ou outras funções de rede social
                disponíveis em nosso Website ou App. As informações que Você nos
                fornece podem incluir seu nome, endereço, endereço de e-mail,
                número de telefone, informações financeiras (incluindo
                informações de cartão de crédito, cartão de débito ou conta
                bancária), motivo de pagamento, localização geográfica,
                inscrição perante o Cadastro de Pessoas Físicas do Ministério da
                Economia – CPF/ME, descrição pessoal e fotografia. Caso Você
                deixe de nos informar esses dados pessoais, é possível que isso
                afete nossa capacidade de lhes prestar nossos Produtos e
                Serviços;
              </p>
              <p>
                2.2.1.2. Em alguns casos, como, por exemplo, quando Você envia
                ou recebe certas transações de alto valor ou atue com alto
                volume de operações, ou, ainda, quando for necessário para
                atender às normas de prevenção à lavagem de dinheiro,
                financiamento do terrorismo, ou qualquer outra exigência legal,
                bem como às nossas políticas internas de <em>compliance</em>, em
                cumprimento às normas aplicáveis a nossa atividade, pode ser
                necessário que a Corretora solicite a Você informações
                adicionais de natureza comercial, de capacidade financeira ou de
                identificação; e
              </p>
              <p>
                2.2.1.3.Ao nos fornecer os dados pessoais de qualquer indivíduo
                (que não seja Você) que receba pagamentos seus enquanto Você
                utiliza os nossos Produtos e Serviços, Você garante que obteve o
                consentimento desse indivíduo para compartilhá-los conosco, bem
                como o consentimento para que possamos coletar, utilizar,
                compartilhar ou de qualquer outra forma tratar tais dados
                pessoais, para os fins estabelecidos nesta Política de
                Privacidade.
              </p>
              <p>
                2.2.2. Informações que coletamos sobre Você. Com relação ao seu
                uso de nossos Produtos e Serviços, por força da Lei Geral de
                Proteção de Dados e da Resolução 4.658/18 do Banco Central,
                poderemos coletar automaticamente as seguintes informações:
              </p>
              <p>
                2.2.2.1.detalhes das transações que Você realizou ao utilizar
                nossos Produtos e Serviços, incluindo a localização geográfica
                de onde a transação se origina;
              </p>
              <p>
                2.2.2.2.informações técnicas, incluindo o endereço do Protocolo
                de Internet (<em>Internet Protocol – IP</em>) usado para
                conectar seu computador à Internet, suas informações de login,
                tipo e versão de navegador de internet, configuração de fuso
                horário, tipos e versões de plug-in do navegador de internet,
                sistema operacional e plataforma; e
              </p>
              <p>
                2.2.2.3.informações sobre sua navegação, incluindo o fluxo de
                cliques em um Localizador Uniforme de Recursos (<em
                  >Uniform Resource Locators – URL</em
                >) que leve para, ou esteja contido em, nosso website ou
                aplicativo (incluindo a data e hora), produtos que Você
                visualizou ou pesquisou, tempos de resposta da página, erros de
                download, duração das visitas a determinadas páginas,
                informações de interação com as páginas (como o uso da barra de
                rolagem, cliques e locais por onde Você navegou com o mouse),
                métodos usados para sair da página, bem como qualquer número de
                telefone usado para ligar para o Sistema de Atendimento ao
                Cliente (SAC/Ouvidoria).
              </p>
              <p>
                2.2.3. Informações que recebemos de outras fontes. Podemos ter
                acesso a informações sobre Você em caso de utilização de
                qualquer um dos outros websites que operamos ou os outros
                Produtos e Serviços que fornecemos. Podemos, também, receber
                informações sobre Você de terceiros com quem trabalhamos. Por
                exemplo:
              </p>
              <p>
                2.2.3.1.os bancos e demais instituições que Você usa para nos
                transferir dinheiro fornecerão suas informações pessoais
                básicas, como seu nome e endereço, bem como suas informações
                financeiras, como os dados da sua conta bancária ou conta de
                pagamento;
              </p>
              <p>
                2.2.3.2.parceiros comerciais podem nos fornecer seu nome e
                endereço, bem como informações financeiras, como informações;
              </p>
              <p>
                2.2.3.3.empresas de publicidade, de pesquisa e de análise
                estatística (<em>analytics</em>) podem nos fornecer informações
                pseudonimizadas sobre Você, como por exemplo, como Você
                encontrou nosso website;
              </p>
              <p>
                2.2.3.4.as agências de análise de crédito não nos fornecem
                nenhuma informação pessoal sobre Você, mas podem ser usadas por
                nós para corroborar as informações que Você nos forneceu.
              </p>
              <p>2.2.4. Dados Pessoais Sensíveis</p>
              <p>
                2.2.4.1.A Corretora trata alguns dados pessoais sensíveis quando
                conduzimos a verificação de documentos de identidade que contêm
                dados biométricos. A finalidade desse tratamento é a prevenção à
                fraudes, lavagem de dinheiro e financiamento ao terrorismo, bem
                como garantir a segurança de nossos clientes no processo de
                identificação e autenticação de cadastros. Limitamos esse
                tratamento ao mínimo necessário para alcançar essa finalidade.
              </p>
              <ol start="3">
                <li>
                  <strong>3. Proteção de Dados e Informações Pessoais</strong>
                </li>
              </ol>
              <p>
                3.1. A Corretora tem como compromisso zelar e tratar as
                informações de nossos clientes e demais titulares de dados
                utilizando medidas que visam garantir a proteção, a manutenção
                da privacidade, integridade, disponibilidade e confidencialidade
                dos dados pessoais tratados em nosso ambiente. Além de
                implementar medidas para prevenir, detectar e reduzir a
                vulnerabilidade a incidentes em nossos ambientes tecnológicos.
                Por exemplo, criptografamos ou anonimizamos certas informações
                pessoais confidenciais, também exigimos que nossos fornecedores
                protejam tais informações contra acesso, uso e divulgação não
                autorizados. Para mais informações, visite nossa Política de
                Segurança Cibernética disponível em nosso site.
              </p>
              <p>
                3.2. Restringimos o acesso a suas informações pessoais aos
                funcionários da Corretora que necessitam acessá-las para
                desempenhar suas funções. Orientamos e treinamos continuamente
                nossos funcionários sobre a importância da confidencialidade e
                privacidade das informações pessoais de clientes. De forma a
                garantir o compromisso de zelar e tratar as informações de
                nossos clientes e demais titulares de dados, a Corretora utiliza
                um Acordo de Confidencialidade e Não divulgação (NDA) onde
                nossos funcionários/ colaboradores se comprometem com a
                confidencialidade e privacidade das informações a que têm
                acesso. Mantemos salvaguardas físicas, eletrônicas e
                procedimentais, em conformidade com as leis e regulamentos
                aplicáveis, para proteger suas informações pessoais de acessos
                não autorizados.
              </p>
              <p>
                3.3. Muito embora adotemos todas essas medidas com o intuito de
                garantir a integridade, disponibilidade e proteção de seus dados
                pessoais, é possível que ocorra incidentes de segurança causados
                por atos ilícitos de terceiros. Encorajamos Você a nos comunicar
                imediatamente em caso de suspeita de qualquer desses eventos por
                meio do e-mail <a href="mailto:lgpd@ozcambio.com.br"
                  >comiteprivacidade@ozcambio.com.br</a
                >.
              </p>
              <ol start="4">
                <li><strong>4. Utilização de Dados Pessoais</strong></li>
              </ol>
              <p>
                4.1. A Corretora utiliza seus dados para as seguintes
                finalidades:
              </p>
              <p>
                4.1.1. para cumprir com as obrigações relativas ao seu contrato
                conosco e fornecer-lhe as informações, produtos e serviços;
              </p>
              <p>
                4.1.2. para cumprir com as obrigações legais e/ou regulatórias
                aplicáveis, em especial aqueles de identificação das partes
                envolvidas em uma transação e de prevenção à lavagem de
                dinheiro;
              </p>
              <p>4.1.3. para informá-lo sobre alterações em nossos Serviços;</p>
              <p>
                4.1.4. como parte de nossos esforços para manter nossos Serviços
                seguros e protegidos;
              </p>
              <p>
                4.1.5. para administrar nossos Serviços e para operações
                internas, incluindo solução de problemas, análise de dados,
                testes, estudos e para fins estatísticos ou de pesquisa;
              </p>
              <p>
                4.1.6. para melhorar nossos Serviços e garantir que eles sejam
                prestados da maneira mais eficaz;
              </p>
              <p>
                4.1.7. para medir ou analisar a eficácia da publicidade que
                ofertamos e entregar publicidade que seja relevante para Você;
              </p>
              <p>
                4.1.8. para permitir que Você participe de recursos interativos
                de nossos Serviços, quando Você optar por fazê-lo;
              </p>
              <p>
                4.1.9. para fornecer a Você informações sobre outros bens e
                serviços semelhantes que nós oferecemos; e
              </p>
              <p>
                4.1.10. para combinar as informações que recebemos de outras
                fontes com as que Você nos fornece e as que coletamos sobre
                Você. Podemos usar essas informações e as informações combinadas
                para os fins acima estabelecidos.
              </p>
              <ol start="5">
                <li>
                  <strong>5. Compartilhamento de suas Informações</strong>
                </li>
              </ol>
              <p>
                5.1. A Corretora pode compartilhar suas informações com
                terceiros, incluindo:
              </p>
              <p>
                5.1.1. a IF, afiliadas, parceiros comerciais, fornecedores e
                subcontratados para a execução de qualquer contrato que
                celebremos com Você, ou que celebremos com eles e de alguma
                forma sejam relacionados à prestação de serviços a Você;
              </p>
              <p>5.1.2. – excluir ;</p>
              <p>
                5.1.3. provedores de análise de estatísticas
                (<em>analytics</em>) e de mecanismos de busca, que auxiliam na
                melhoria e otimização do nosso website; e
              </p>
              <p>5.1.4. entidades ou subsidiárias do grupo.</p>
              <p>
                5.2. Podemos revelar suas informações pessoais a terceiros em
                outras situações específicas, incluindo:
              </p>
              <p>
                5.2.1. afiliadas, parceiros comerciais, fornecedores e
                subcontratados para a execução de qualquer contrato que
                celebremos com Você, ou que celebremos com eles e de alguma
                forma sejam relacionados à prestação de serviços a Você;
              </p>
              <p>
                5.2.2. no caso de vendermos ou comprarmos qualquer negócio ou
                ativo, hipótese em que poderemos divulgar seus dados pessoais ao
                potencial vendedor ou comprador de tal negócio ou ativo;
              </p>
              <p>
                5.2.3. se tivermos o dever de divulgar ou compartilhar seus
                dados pessoais para cumprir com qualquer obrigação legal ou
                regulatória ou para fazer cumprir ou efetivar nosso Contrato de
                Prestação de Serviços e outros contratos aplicáveis; ou para
                proteger os direitos, propriedade ou segurança da Corretora, de
                nossos clientes ou de outros. Isso inclui a troca de informações
                com outras empresas e entidades para fins de proteção contra
                fraudes e redução do risco de crédito;
              </p>
              <p>
                5.2.4. para nos ajudar a conduzir ou cooperar em investigações
                de fraudes ou outras atividades ilegais, quando acreditarmos que
                é razoável e apropriado fazê-lo;
              </p>
              <p>5.2.5. para prevenir e detectar fraudes ou crimes;</p>
              <p>
                5.2.6. em resposta a uma intimação, mandado, ordem de uma
                autoridade administrativa ou judicial, ou conforme exigido por
                lei;
              </p>
              <p>5.2.7. para avaliar riscos financeiros e securitários;</p>
              <p>
                5.2.8. para recuperar créditos ou em caso de seu inadimplemento
                ou insolvência; e
              </p>
              <p>
                5.2.9. para desenvolver serviços e sistemas de relacionamento
                com clientes.
              </p>
              <p>
                5.3. Não temos uma lista de todos os terceiros com os quais
                compartilhamos seus dados, pois isso dependerá do uso específico
                que seja feito de nossos Serviços. No entanto, se Você desejar
                obter mais informações sobre com quem compartilhamos seus dados
                ou receber uma lista específica para Você, solicite isso
                escrevendo para <a href="mailto:lgpd@ozcambio.com.br"
                  >comiteprivacidade@ozcambio.com.br</a
                >.
              </p>
              <ol start="6">
                <li>
                  <strong
                    >6. Transferência e armazenamento de dados pessoais</strong
                  >
                </li>
              </ol>
              <p>
                6.1. Para fornecer nossos Serviços a Você, pode ser necessário
                transferir seus dados para os terceiros descritos no item 5.1
                que estão estabelecidos fora do território nacional brasileiro.
                Nesses casos, nós e nossos parceiros tomaremos medidas de
                segurança técnicas, físicas e organizacionais adequadas para
                proteger seus dados. Também teremos proteções contratuais
                adequadas (e.g. normas corporativas globais, cláusulas-padrão
                contratual ou <em>Privacy Shield</em>) em vigor com esses
                terceiros que receberão dados fora do território nacional
                brasileiro.
              </p>
              <ol start="7">
                <li>
                  <strong
                    >7. Criação de perfil e Tomada de Decisão
                    Automatizada</strong
                  >
                </li>
              </ol>
              <p>
                7.1. Podemos usar alguns de seus dados – como seu país de
                residência e histórico de transações – para personalizar nossos
                Serviços e as informações que fornecemos a Você, bem como para
                atender às suas necessidades. Por exemplo, se Você
                frequentemente transfere recursos de uma moeda em particular
                para outra, podemos usar essa informação para comunicá-lo sobre
                novas atualizações de produtos ou recursos que podem ser úteis
                para Você. Quando adotarmos essa conduta, tomaremos todas as
                medidas necessárias para garantir que sua privacidade e
                segurança sejam protegidas – e usaremos dados pseudonimizados
                sempre que possível.
              </p>
              <p>
                7.2. Poderemos utilizar a Tomada de Decisões Automatizadas
                (“TDA”) para melhorar sua experiência ou ajudar a combater
                crimes financeiros. Por exemplo, para que possamos fornecer-lhe
                um serviço rápido e eficiente, poderemos usar o TDA para
                verificar seus documentos de identidade, ou para confirmar a
                exatidão das informações que Você nos forneceu.
              </p>
              <ol start="8">
                <li><strong>8. Retenção de Dados Pessoais</strong></li>
              </ol>
              <p>
                8.1. A Corretora é obrigada por lei a manter seus dados pessoais
                e transacionais armazenados mesmo após o encerramento de seu
                contrato de prestação de serviços conosco. Nós limitamos o
                acesso aos dados que sejam pertinentes e não excessivos para o
                atendimento de obrigações legais ou regulatórias e não os
                tratamos a menos que seja absolutamente necessário.
              </p>
              <p>
                8.2. Excluiremos dados que não são mais exigidos por obrigações
                legais ou regulatórias. No entanto, os seus dados pessoais
                também poderão ser retidos após o encerramento de seu contrato
                para fins de garantir o nosso exercício regular de direitos em
                processo judicial, administrativo ou arbitral, quando necessário
                para atender aos nossos interesses legítimos ou de terceiros, ou
                quando de outra forma autorizado pela legislação aplicável.
              </p>
              <ol start="9">
                <li><strong>9. Cookies</strong></li>
              </ol>
              <p>
                9.1. Alguns de nossos Produtos e Serviços usam cookies para
                distinguir Você de outros usuários, identificar como Você usa os
                Produtos e Serviços. Isso nos ajuda a proporcionar uma boa
                experiência e nos permite melhorar nossos Produtos e Serviços.
              </p>
              <ol start="10">
                <li><strong>10. Seus Direitos</strong></li>
              </ol>
              <p>
                10.1. Sujeito às leis aplicáveis, Você tem o direito de acessar
                informações que mantemos sobre Você. Se Você tiver alguma dúvida
                em relação ao uso de suas informações pessoais, entre em contato
                conosco. Você tem direito de requerer:
              </p>
              <p>
                10.1.1. a confirmação da existência de tratamento, com o
                fornecimento de mais detalhes sobre o uso que fazemos de suas
                informações, no prazo de até 30 (trinta) dias contados da sua
                requisição;
              </p>
              <p>
                10.1.2. o fornecimento de uma cópia das informações que Você nos
                forneceu, no prazo de até 30 (trinta) dias contados da sua
                requisição;
              </p>
              <p>
                10.1.3. a atualização de quaisquer informações pessoais que
                mantemos que estejam incompletas, inexatas ou desatualizadas;
              </p>
              <p>
                10.1.4. a anonimização, bloqueio ou eliminação de quaisquer
                informações pessoais que não sejam mais necessárias, que sejam
                excessivas, ou dispensáveis de acordo com a legislação
                aplicável. Poderá não ser possível excluir seus dados no momento
                da solicitação, como explicado no item 8 acima, mas tão logo
                transcorra o prazo necessário iremos atendê-la;
              </p>
              <p>
                10.1.5. a eliminação de dados pessoais que tenham sido tratados
                sem o seu consentimento, exceto nos casos em que a lei admitir a
                sua conservação, ou na hipótese do item 8 acima;
              </p>
              <p>
                10.1.6. a portabilidade dos dados pessoais a outro fornecedor de
                serviço ou produto nos termos da Lei Geral de Proteção de Dados
                (LGPD)
              </p>
              <p>
                10.1.7. informação das entidades públicas e privadas com as
                quais compartilhamos seus dados;
              </p>
              <p>10.1.8. ;</p>
              <p>
                10.1.9. quando tomadas decisões unicamente com base no TDA
                previsto no item 7 acima, Você poderá solicitar que forneçamos
                informações sobre a metodologia e critérios de tomada de decisão
                e nos peça para verificar se a decisão automatizada foi tomada
                corretamente. Podemos rejeitar o pedido, conforme permitido pela
                lei aplicável, inclusive quando o fornecimento das informações
                resultar em uma divulgação de um segredo comercial ou industrial
                ou interfira na prevenção ou detecção de fraudes ou outros
                crimes. No entanto, nestas circunstâncias, geralmente
                verificamos se o algoritmo e a base de dados estão funcionando
                regularmente sem erro ou algum tipo de viés, de modo a ajustar o
                tratamento, se necessário;
              </p>
              <p>
                10.1.10. oposição a qualquer tratamento com fundamento em uma
                das hipóteses em que seu consentimento é dispensado, caso tenha
                ocorrido o descumprimento ao disposto na legislação aplicável,
                resguardado o interesse público que possa justificar a
                continuidade do tratamento; e
              </p>
              <p>
                10.1.11. oposição a qualquer tratamento com fundamento no nosso
                legítimo interesse ou de terceiros, a menos que nossas razões
                para realizar a atividade de tratamento prevaleçam sobre
                qualquer prejuízo aos seus direitos de proteção de dados.
              </p>
              <p>
                10.2. O exercício desses direitos está sujeito a certas exceções
                para resguardar o interesse público (e.g., a prevenção ou
                detecção de crimes) e nossos interesses (e.g., a manutenção de
                um privilégio legal). Se Você exercer qualquer um desses
                direitos, verificaremos a possibilidade de atendê-lo. Caso não
                seja possível atender imediatamente a sua requisição,
                indicaremos as razões de fato ou de direito que nos impedem. Na
                maioria dos casos, responderemos dentro de um mês, a menos que
                tenha sido previsto prazo inferior nesta Política de Privacidade
                ou na legislação aplicável.
              </p>
              <ol start="11">
                <li><strong>11. Links de terceiros</strong></li>
              </ol>
              <p>
                11.1. Nossos Serviços podem, de tempos em tempos, conter links
                de e para os websites de nossas redes parceiras, anunciantes e
                afiliados. Se Você clicar em um link para qualquer um desses
                websites, observe que esses websites têm suas próprias políticas
                de privacidade e que não assumimos qualquer responsabilidade por
                eles, exceto com relação àqueles que são de nossa propriedade.
                Por favor, verifique essas políticas antes de enviar quaisquer
                dados pessoais para esses websites.
              </p>
              <ol start="12">
                <li>
                  <strong
                    >12. Responsabilidade e comunicação em casos de incidentes
                    de segurança</strong
                  >
                </li>
              </ol>
              <p>
                12.1. A Corretora está sujeita ao regime de responsabilização
                previsto na legislação aplicável.
              </p>
              <p>
                Na hipótese de, notificarmos a Autoridade Nacional de Proteção
                de Dados (ANPD) sobre a ocorrência de um incidente de segurança
                que possa acarretar risco ou dano relevante a Você,
                imediatamente lhe informaremos do ocorrido e das ações para
                mitigação dos eventuais danos.
              </p>
              <ol start="13">
                <li>
                  <strong
                    >13. Alterações em nossa política de privacidade</strong
                  >
                </li>
              </ol>
              <p>
                13.1. Para estarmos atualizados quanto às mudanças na
                legislação, às melhores práticas e às mudanças na forma como
                tratamos informações pessoais, poderemos revisar esta Política
                de Privacidade a qualquer momento sem aviso prévio,
                disponibilizando uma versão revisada em nosso website. Para
                ficar atualizado sobre qualquer alteração, verifique-o
                periodicamente.
              </p>
              <ol start="14">
                <li><strong>14. Contato</strong></li>
              </ol>
              <p>
                14.1. Envie quaisquer perguntas, comentários ou solicitações
                sobre esta Política de Privacidade para nosso Comitê de
                Privacidade responsável pelo tratamento de dados pessoais em <a
                  href="mailto:lgpd@ozcambio.com.br"
                  >comiteprivacidade@ozcambio.com.br</a
                >.
              </p>
              <p>
                14.2. Se Você entender que não respondemos adequadamente às suas
                perguntas ou preocupações, ou se entender que seus direitos à
                proteção de dados ou privacidade foram violados, Você poderá
                contatar a ANPD ou outra autoridade de supervisão legitimada, se
                a ANPD ainda não estiver em funcionamento.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
